export default "__VITE_ASSET__BSAfbjES__"